"use client";

import React from "react";

import { LandingPage } from "@/components/landing-page/landing-page";

const HomeScreen = () => {
    return <LandingPage />;
};

export default HomeScreen;
